import React from "react";

import {
  getCountOfTotalItems,
  isSpinnerEnabled,
  parseToNumber,
  parseToThousandSeperatorDecimalNumber,
} from "../../utility";
import {
  buttonNameConstants,
  transactionConstants,
} from "../../../constants";
import { connect } from "react-redux";
import { CloseIcon } from "../../../assets/icons/iconsProvider";
import { STORE_CARD_PAYMENT_TYPE_ENUMS } from "../../../system/globalEnums";

const TransactionPaymentHistory = ({
  spinnerArray,
  transactionData,
  handleReturnPayment,
}) => {
  let remainingTotal = parseToNumber(transactionData.totalAmountToPay);

  return transactionData.paymentHistory.history.map((history) => {
    if (history?.isUndoTransaction) {
      remainingTotal -= history.currentAmountToPay;
    }
    return history?.isUndoTransaction ? (
      <>
        {history.paymentType !== transactionConstants.GIFT_CARD && (
          <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-2">
            <div className="d-flex align-items-center gap-2">
              <span className="subtotal-heading">
                {history.paymentType === transactionConstants.CREDIT_CARD
                  ? buttonNameConstants.CREDIT_CARD
                  : history.paymentType === transactionConstants.STORE_CREDIT
                  ? buttonNameConstants.STORE_CREDIT
                  : history.paymentType === transactionConstants.OTHER
                  ? buttonNameConstants.OTHER
                  : buttonNameConstants.CASH}
              </span>
            </div>
            <span className="payment-cart-productname d-flex justify-content-center align-items-center gap-2">
              $
              {parseToThousandSeperatorDecimalNumber(
                history.currentAmountToPay
              )}
              {transactionData?.paymentMethod !==
                transactionConstants.PAYMENT_COMPLETE && (
                <button
                  onClick={() => {
                    handleReturnPayment(history);
                  }}
                  disabled={isSpinnerEnabled(
                    spinnerArray,
                    transactionConstants.MAKE_TRANSACTION
                  )}
                  className="return-payment-button"
                >
                  <CloseIcon />
                </button>
              )}
            </span>
          </div>
        )}
        {history.paymentType === transactionConstants.CASH &&
          history.isUndoTransaction && (
            <>
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading gift-card-history-heading">
                    Tendered Amount:
                  </span>
                </div>
                <span className="payment-cart-productname gift-card-history-heading">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    history.cashTenderedAmount
                  )}
                </span>
              </div>
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading gift-card-history-heading">
                    Change Owed:
                  </span>
                </div>
                <span className="payment-cart-productname gift-card-history-heading">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    history.cashChangeOwed
                  )}
                </span>
              </div>
            </>
          )}
        {history.paymentType === transactionConstants.CREDIT_CARD &&
          history.activeCardPaymentType ===
            STORE_CARD_PAYMENT_TYPE_ENUMS.VERIFONE &&
          history.isUndoTransaction && (
            <>
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading gift-card-history-heading">
                    Card Type:
                  </span>
                </div>
                <span className="payment-cart-productname gift-card-history-heading">
                  {history.creditCard.paymentBrand}
                </span>
              </div>
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading gift-card-history-heading">
                    Last 4:
                  </span>
                </div>
                <span className="payment-cart-productname gift-card-history-heading">
                  {history.creditCard.maskedPan}
                </span>
              </div>{" "}
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading gift-card-history-heading">
                    Auth #:
                  </span>
                </div>
                <span className="payment-cart-productname gift-card-history-heading">
                  {history.creditCard.paymentTokenValue}
                </span>
              </div>
            </>
          )}
        {history.paymentType === transactionConstants.GIFT_CARD &&
          history.isUndoTransaction && (
            <>
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading">
                    {history?.giftCardName}
                  </span>
                </div>
                <span className="payment-cart-productname d-flex justify-content-center align-items-center gap-2">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    history.currentAmountToPay
                  )}
                  {transactionData?.paymentMethod !==
                    transactionConstants.PAYMENT_COMPLETE && (
                    <button
                      onClick={() => {
                        handleReturnPayment(history);
                      }}
                      disabled={isSpinnerEnabled(
                        spinnerArray,
                        transactionConstants.MAKE_TRANSACTION
                      )}
                      className="return-payment-button"
                    >
                      <CloseIcon />
                    </button>
                  )}
                </span>
              </div>
              <div className="d-flex w-100 justify-content-between align-items-center mt-2 pt-1">
                <div className="d-flex align-items-center gap-2">
                  <span className="subtotal-heading gift-card-history-heading">
                    Remaining Balance
                  </span>
                </div>
                <span className="payment-cart-productname gift-card-history-heading">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    history.remainingBalance
                  )}
                </span>
              </div>
            </>
          )}

        {remainingTotal <= 0 ? (
          ""
        ) : (
          <div className="d-flex justify-content-between align-items-center w-100 mt-2 border-top pt-2">
            <div className="d-flex align-items-center gap-2">
              <span className="subtotal-heading d-flex justify-centent-center align-items-center gap-3">
                SALE TOTAL{" "}
                <span className="opacity-75">
                  {getCountOfTotalItems(
                    transactionData?.inventory || 0,
                    "quantity"
                  ) || 0}{" "}
                  Items
                </span>
              </span>
            </div>
            <span className="payment-cart-productname">
              ${parseToThousandSeperatorDecimalNumber(remainingTotal)}
            </span>
          </div>
        )}
      </>
    ) : (
      ""
    );
  });
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export transaction Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionPaymentHistory);
